//slider
$('.men__blog-slider').bxSlider({
	easing: 'swing',
	infiniteLoop: false,
	auto: true,
	pause: 6000,
	onSlideAfter: function($slideElement, oldIndex, newIndex){
		// do funky JS stuff here
		$('.slide.active').removeClass('active');
		var realIndex = newIndex + 1;
		$('.slide:nth-child(' + realIndex  + ')').addClass('active');
	}
});

$('.menhome-post-title').dotdotdot({
		/*	The text to add as ellipsis. */
		ellipsis	: '... ',

		/*	How to cut off the text/html: 'word'/'letter'/'children' */
		wrap		: 'word',

		/*	Wrap-option fallback to 'letter' for long words */
		fallbackToLetter: true,

		/*	jQuery-selector for the element to keep and put after the ellipsis. */
		after		: null,

		/*	Whether to update the ellipsis: true/'window' */
		watch		: false,

		/*	Optionally set a max-height, can be a number or function.
			If null, the height will be measured. */
		height		: null,

		/*	Deviation for the height-option. */
		tolerance	: 0,

		/*	Callback function that is fired after the ellipsis is added,
			receives two parameters: isTruncated(boolean), orgContent(string). */
		callback	: function( isTruncated, orgContent ) {},

		lastCharacter	: {

			/*	Remove these characters from the end of the truncated text. */
			remove		: [ ' ', ',', ';', '.', '!', '?' ],

			/*	Don't add an ellipsis if this array contains
				the last character of the truncated text. */
			noEllipsis	: []
		}
	});

// Progress bar on mobile
$('body').on({
    'touchmove': function() {
	    var scrollPos = $(document).scrollTop();
			var percentagePos = scrollPos/($('.men-post').height() - $(window).height());
			var barPercentage = 100 * percentagePos + "%";
			$(".men-progressbar").css({
				"width": barPercentage + "%"
			});
    }
});

// Progress bar
$(window).scroll(function () {
	var scrollPos = $(document).scrollTop();
	var percentagePos = scrollPos/($('.men-post').height() - $(window).height());
	var barPercentage = 100 * percentagePos + "%";
	$(".men-progressbar").css({
		"width": barPercentage
	});
});
// Analytics track click signups header && footer
$(".men-topbar-cta").click(function() {
	eventText = $(this).text();
	var data = {
		eventCategory : 'header',
		eventAction : 'main cta',
		eventLabel: eventText
	};
	// data.eventCategory =  'header';
	// data.eventAction =  'main cta';
	// data.eventLabel'=  $(this).text();
	analytics.track('GAevent', data);
});
